module.exports = __webpack_public_path__ + "img/canvas-bg1.eb103e13.png";